import { DeleteOutlined } from '@ant-design/icons'
import { Popconfirm, Tooltip, message } from 'antd'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { EmptyText } from '../CellText'
import { LinkedWorkWrapper } from './LinkedStyled'

const LinkedWork = props => {
  const {
    linkedWorkList,
    emptyText,
    style,
    documentCode,
    internalDocumentStore,
    onSuccess,
  } = props

  const renderTitle = string => {
    if (!string) return null
    if (string.length <= 100) return string
    return (
      <Tooltip title={string}>{string.substring(0, 100).concat('...')}</Tooltip>
    )
  }

  const handleUnlinkWork = async linkCode => {
    try {
      if (documentCode) {
        await internalDocumentStore.unlinkWork(documentCode, linkCode)
        message.success('Đã xóa liên kết công việc')
        if (onSuccess) await onSuccess()
      }
    } catch (error) {
      message.error('Xóa liên kết thất bại')
    }
  }

  return (
    <LinkedWorkWrapper style={style}>
      {linkedWorkList && linkedWorkList.length > 0 ? (
        linkedWorkList.map(link => {
          return (
            <div
              key={link.code}
              style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <a
                className="linked"
                style={{ flex: 1, minWidth: 0 }}
                onClick={() =>
                  window.open('/works/view/' + link.code, '_blank')
                }>
                <span>{renderTitle(link.title)}</span>
              </a>
              <Popconfirm
                title="Xác nhận xóa liên kết công việc này?"
                okText="Xóa"
                cancelText="Hủy"
                okButtonProps={{ danger: true }}
                placement="topRight"
                getPopupContainer={triggerNode => triggerNode.parentNode}
                onConfirm={() => handleUnlinkWork(link.code)}>
                <DeleteOutlined
                  style={{
                    fontSize: 13,
                    color: '#ff4d4f',
                    cursor: 'pointer',
                    flexShrink: 0,
                  }}
                />
              </Popconfirm>
            </div>
          )
        })
      ) : (
        <EmptyText>{emptyText || 'Không có.'}</EmptyText>
      )}
    </LinkedWorkWrapper>
  )
}

export default inject('internalDocumentStore')(observer(LinkedWork))
